import { UserApi } from "@/api/user.api";
import { LoaderFunctionArgs } from "react-router-dom";

export default async function adminProfileOrdersLoader({
  params,
}: LoaderFunctionArgs) {
  const { userId } = params;

  if (!userId) {
    throw new Error("User ID is required");
  }

  const orders = await UserApi.getOrdersByUid(userId);

  return { orders: orders.data.orders };
}
